import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { extractErrorMessage } from "@/api/axios";

/** Maps API/unknown errors to a user-facing string, with a translated fallback. */
export function useApiErrorMessage() {
  const { t } = useTranslation();
  return useCallback(
    (err: unknown) => extractErrorMessage(err, t("common.unknownError")),
    [t],
  );
}
